const AltcraftPopupModel = {};

AltcraftPopupModel.TARGET_FIELD = {
  DEFAULT_AUTH: 'push_sub_default_auth',
  XUR: 'push_sub_xur',
};

AltcraftPopupModel.TYPE = {
  EMAIL: 'email',
  PUSH: 'push',
  PUSH_PROMPT: 'pushPrompt',
};

AltcraftPopupModel.ACTION = {
  SHOWN: 'shown',
  CLICKED_YES: 'clicked yes',
  CLICKED_NO: 'clicked no',
};

AltcraftPopupModel.LABEL = {
  EMAIL_SUB: 'email sub',
  WEB_PUSH_SUB: 'web push sub',
};

AltcraftPopupModel.LOCALSTORAGE = {
  EMAIL_COOLDOWN: 'altcraftEmailCooldown',
  EMAIL_SUBSCRIBED: 'altcraftEmailSubscribed',
  PUSH_IGNORED: 'altcraftPushIgnored',
  PUSH_COOLDOWN: 'altcraftPushCooldown',
  PUSH_SUBSCRIBED: 'altcraftPushSubscribed',
  XUR_EMAIL_COOLDOWN: 'altcraftXurEmailCooldown',
  XUR_PUSH_SUBSCRIBED: 'altcraftXurPushSubscribed',
};

AltcraftPopupModel.TEXT = {
  email: {
    label: 'Be the first to get discounts!',
    text: 'Subscribe for exclusive deals, discounts, and promo codes',
    analyticsLabel: 'email sub',
    cooldown: 'altcraftEmailCooldown',
  },

  push: {
    label: 'Want the best gaming deals? ',
    text: 'Turn on push notifications for the latest updates, discounts, and promos',
    analyticsLabel: 'web push sub',
    cooldown: 'altcraftPushCooldown',
  },

  pushPrompt: {
    label: 'Please click "Allow" here ',
    analyticsLabel: 'web push sub',
  },
};

export default AltcraftPopupModel;
